import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import SymptomsContainer from "./SymptomsContainer";

export default function SymptomsPage() {
  const navigate = useNavigate();
  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Patient Symptoms"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate(`/user/quick-actions/overall-symptoms/add`)}
        >
          Add
        </Button>
      </Flex>
      <SymptomsContainer />
    </Flex>
  );
}
